import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { ActionState, ButtonWrapper } from '../../button/button.model';

@Component({
  selector: 'ui-feedback-footer',
  templateUrl: './feedback-footer.component.html',
  styleUrl: './feedback-footer.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class FeedbackFooterComponent {
  @Input() state!: ActionState;
  @Input() linkConfig: ButtonWrapper | undefined;
  @Input() linkDataTest: string | undefined;
  @Input() primaryConfig: ButtonWrapper | undefined;
  @Input() primaryDataTest: string | undefined;
  @Input() primaryTrackingValue = '';
  @Input() secondaryConfig: ButtonWrapper | undefined;
  @Input() secondaryDataTest: string | undefined;
  @Input() tertiaryConfig: ButtonWrapper | undefined;
  @Input() tertiaryDataTest: string | undefined;
  @Input() isLoading = false;
  @Input() isCancellableLoading = false;

  @Output() handlePrimaryClick = new EventEmitter();
  @Output() handleSecondaryClick = new EventEmitter();
  @Output() handleTertiaryClick = new EventEmitter();
}
